import DropdownButton from '@/components/DropdownButton.vue';
import { getUser } from '@/common/api';
import { Router, RouteLocationNormalized } from 'vue-router';
import { statusMap, StatusKey, UNKNOWN_STATUS } from '@/common/constants';

import tokenService from '@/services/TokenService';
import { handleError } from '@/common/errors';

export const logout = async (router: Router) => {
  tokenService.clearToken();
  await router.push('/login');
};

export const checkIsAdmin = async () => {
  try {
    const response = await getUser();
    const user = response.data;
    return user.isAdmin;
  } catch (error: unknown) {
    handleError(error, 'Failed to get user data');
  }
};

export const getNavigationButtons = async (router: Router) => {
  const navigationButtons = [
    {
      component: DropdownButton,
      props: {
        buttonText: 'Profile Settings',
        buttonClasses: 'text-dark',
        handler: function () {
          router.push('/user-profile?tab=settings');
        },
      },
    },
  ];

  const isAdmin = await checkIsAdmin();

  if (isAdmin) {
    navigationButtons.push({
      component: DropdownButton,
      props: {
        buttonText: 'Admin Settings',
        buttonClasses: 'text-dark',
        handler: function () {
          router.push('/user-profile?tab=admin');
        },
      },
    });
  }

  navigationButtons.push({
    component: DropdownButton,
    props: {
      buttonText: 'Log Out',
      buttonClasses: 'text-danger',
      handler: async function () {
        await logout(router);
      },
    },
  });

  return navigationButtons;
};

export const defineUserProfileTab = (route: RouteLocationNormalized) => {
  const tab = route.query.tab;
  switch (tab) {
    case 'settings':
      return 'UserProfileCommonSettings';
    case 'admin':
      return 'UserProfileAdminSettings';
    default:
      return 'UserProfileSessionsList';
  }
};

export const getMappedStatus = (status: string) => {
  return statusMap[status as StatusKey] || UNKNOWN_STATUS;
};
